import { type ReactNode } from 'react';
import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './@configs/query-client';
import { theme } from './@mui';
import { ChannelsProvider } from './context/channels';
import { NotificationProvider } from './context/notification';
import { RecommendationProfileProvider } from './context/recommendation-profile/provider';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <ChannelsProvider>
          <NotificationProvider>
            <RecommendationProfileProvider>
              {children}
            </RecommendationProfileProvider>
          </NotificationProvider>
        </ChannelsProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
